// extracted by mini-css-extract-plugin
export default {"skill":"SingleSkill_skill__zhLYP","name":"SingleSkill_name__4hg1R","bar":"SingleSkill_bar__ZbqKk","filling":"SingleSkill_filling__hmiq+"};